"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "varsi": {
    "7b0f97e8": [{
      "hkey": "7382f0ac",
      "slug": "contile-lagadello",
      "name": "Contile-Lagadello",
      "primary": true,
      "skipSearch": false
    }],
    "contile": [{
      "hkey": "7382f0ac",
      "slug": "contile-lagadello",
      "name": "Contile-Lagadello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "c381b6cb": [{
      "hkey": "f7690c20",
      "slug": "varsi",
      "name": "Varsi",
      "primary": true,
      "skipSearch": false
    }],
    "pietrarada": [{
      "hkey": "f7690c20",
      "slug": "varsi",
      "name": "Varsi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b39186fc": [{
      "hkey": "830c9e58",
      "slug": "rocca-vecchia",
      "name": "Rocca Vecchia",
      "primary": true,
      "skipSearch": false
    }],
    "rocca": [{
      "hkey": "830c9e58",
      "slug": "rocca-vecchia",
      "name": "Rocca Vecchia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "56716180": [{
      "hkey": "c59a26a2",
      "slug": "tosca-ferre",
      "name": "Tosca-Ferrè",
      "primary": true,
      "skipSearch": false
    }],
    "tosca": [{
      "hkey": "c59a26a2",
      "slug": "tosca-ferre",
      "name": "Tosca-Ferrè",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;